import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Button,
  Link,
  Box,
} from "@mui/material";

const cases = [
  {
    title: "フジテレビ公式YouTube番組 #シゴトズキ",
    desc: "テレビでもYouTubeでも、「面白い」は一人ではつくれない。 言葉にできない「らしさ」をカタチに。 You Produce株式会社は、企画制作からチャンネル運用、ゲストアサインやロケーション選定、そして編集に至るまで、多岐にわたる業務を手がけています。 これまで数々のプロジェクトで、個性豊かな出演者やクリエイターたちと共に番組をつくりあげてきた私たち。今回は、そんな私たちと携わってきた企画・番組をご紹介します。 清水俊宏ファシリテーター 【毎日のように怒られた】それでも仕事が好きっておかしいですか？ 【テレビの仕事】誰かに話したくなるプロデューサーの内緒話 【1周年】シゴトズキ",
    img: "cases/Shigoto.png",
    url: "https://note.com/youproduce_/n/n1f9b94130e1a",
  },
  {
    title: "Schoo/LoLLL",
    desc: "「いつかは地方で働いてみたいけれど、キャリアダウンになってしまうのでは……」そんな不安を抱いたことはありませんか？\n株式会社Schooの子会社・LoLLL（ロール）が運営するYouTubeチャンネル『LoLLL（ロール）』は、地方で新たな挑戦を続ける経営者や自治体関係者へのインタビューを通じ、地域のリアルな課題や変革のアイデアを紐解くメディアです。\n人生や仕事の選択肢を広げ、自分らしい生き方を模索するすべての人へ。\nこの番組から見えてくる「地方で働くことのリアルと可能性」について、\n今回は、実績をご紹介します。",
    img: "cases/LoLLL.png",
    url: "https://note.com/youproduce_/n/n4a234438f9b3",
  },
  {
    title: "丸善ジュンク堂書店",
    desc: "「本屋さんは、本を売るだけじゃない——」 丸善ジュンク堂書店の公式YouTube「読まない時間の本屋チャンネル」では、作家のトークイベントやカルチャーの裏側など、本好き・知的好奇心旺盛な人必見のコンテンツが日々配信されています。 今回は、このチャンネルの魅力や、個人的に心打たれたおすすめ動画についてたっぷりと語ります。",
    img: "cases/Maruzen.png",
    url: "https://note.com/youproduce_/n/nb892c8352e3f",
  },
  {
    title: "ANOBAKA CH",
    hidden: true,
    desc: "これからの日本経済を担うのは間違いなくスタートアップ企業。50年・100年先の大企業を育てる第一歩とも言える、シード・アーリーフェーズの投資に特化したベンチャーキャピタル、ANOBAKAの公式YouTubeチャンネルを企画・制作しています。 スタートアップ起業家だけでなく、大企業のCVCや新規事業を考えるビジネスパーソンにも学びの多いインタビュー番組を、ゲストに合わせた台本・切り口で、他では聞けないコンテンツにこだわって制作しています。 以下は再生リストです。ぜひご覧ください。 ・CVCのトップに直撃インタビュー ・VC界のレジェンドの本音トーク ・ANOBAKA 代表長野/パー",
    img: "cases/Growth.png",
    url: "https://note.com/youproduce_/n/nd3658143d92c",
  },
];

const Cases = () => (
  <Container id="case" sx={{ py: 10 }}>
    <Box
      sx={{
        pt: { xs: 0, sm: 5, md: 10, lg: 10 },
        pb: { xs: 0, sm: 5, md: 10, lg: 10 },
        px: { xs: 2, md: 2 },
        backgroundColor: "#fff",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Typography
        variant="h1"
        component="div"
        aria-hidden="true"
        sx={{
          position: "absolute",
          top: { xs: "5%", sm: "-12%", md: "-3%" },
          left: "50%",
          transform: "translateX(-50%)",
          fontFamily: "Roboto, sans-serif",
          fontSize: { xs: "64px", sm: "8rem", md: "11rem" },
          fontWeight: "bold",
          color: "rgba(230, 0, 18, 0.05)",
          zIndex: 0,
          userSelect: "none",
          pointerEvents: "none",
          whiteSpace: "nowrap",
          textAlign: "center",
          width: "100%",
        }}
      >
        Cases
      </Typography>

      <Box
        sx={{
          textAlign: "center",
          mb: 8,
          position: "relative",
          zIndex: 1,
          mt: { xs: 4, sm: 0 },
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            color: "#E60012",
            display: "inline-block",
            mb: 1,
            fontSize: { xs: "16px", sm: "1.8rem", md: "2.25rem" },
            fontWeight: "bold",
            fontFamily: "Roboto, sans-serif",
          }}
        >
          事例紹介
        </Typography>
        <Box
          sx={{
            height: 2,
            width: "6%",
            minWidth: "60px",
            bgcolor: "#1D2D5C",
            mx: "auto",
          }}
        />
      </Box>
    </Box>

    <Grid container spacing={3} justifyContent="center">
      {cases.filter((item) => !item.hidden).map((item, i) => (
        <Grid key={i} size={{ xs: 12, md: 4 }} sx={{ display: "flex" }}>
          <Box sx={{ position: "relative", borderRadius: 3, display: "flex", width: "100%" }}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: 3,
                zIndex: 0,
              }}
            />
            <Card
              sx={{
                position: "relative",
                borderRadius: 3,
                maxWidth: 500,
                width: "100%",
                display: "flex",
                mx: "auto",
                backgroundColor: "#fff",
                zIndex: 1,
                overflow: "hidden",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.1)", // サイド用
                "&:hover": {
                  boxShadow: "0px 20px 40px rgba(0,0,0,0.2)", // ホバー時に中央カードっぽい強シャドウ
                },
                "&:hover .hover-button::before": {
                  width: "100%",
                },
                "&:hover .hover-button": {
                  color: "#fff",
                },
                "&:hover .hover-button .arrow": {
                  transform: "translateX(4px)",
                },
                "&:hover .hover-button .arrow-dark": {
                  display: "none",
                },
                "&:hover .hover-button .arrow-white": {
                  display: "block",
                },
              }}
            >
              <CardActionArea
                href={item.url}
                target="_blank"
                sx={{ display: "flex", flexDirection: "column", alignItems: "stretch", flex: 1 }}
              >
                {item.img ? (
                  <CardMedia
                    component="img"
                    image={item.img}
                    alt={item.title}
                    sx={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                      objectFit: "contain",
                      objectPosition: "center",
                      backgroundColor: "#fff",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <Box sx={{ height: "300px", backgroundColor: "#f5f5f5", flexShrink: 0 }} />
                )}
                <CardContent
                  sx={{
                    px: 4,
                    py: 3,
                    minHeight: 240, // 全体高さ調整
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "bold",
                        mb: 1,
                        fontFamily: "Roboto, sans-serif",
                        fontSize: { xs: "16px", md: "23px" },
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: "Roboto, sans-serif",
                        fontSize: { xs: "12px" },
                        whiteSpace: "pre-line",
                      }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                  <Box textAlign="center" mt={3}>
                    <Button
                      variant="outlined"
                      className="hover-button"
                      sx={{
                        position: "relative",
                        color: "#1D2D5C",
                        borderColor: "#1D2D5C",
                        borderRadius: "999px",
                        px: 4,
                        py: 1.5,
                        overflow: "hidden",
                        fontWeight: 400,
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "0%",
                          height: "100%",
                          backgroundColor: "#1D2D5C",
                          zIndex: 0,
                          transition: "all 0.4s ease",
                        },
                        "&:hover::before": {
                          width: "100%",
                        },
                        "&:hover": {
                          color: "#fff",
                        },
                        "& .btn-content": {
                          position: "relative",
                          zIndex: 1,
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        },
                        "& .label": {
                          fontWeight: 400,
                          transition: "font-weight 0.3s ease",
                        },
                        "& .arrow": {
                          transition: "transform 0.3s ease",
                        },
                        "& .arrow-dark": {
                          display: "block",
                        },
                        "& .arrow-white": {
                          display: "none",
                        },
                        "&:hover .arrow-dark": {
                          display: "none",
                        },
                        "&:hover .arrow-white": {
                          display: "block",
                        },
                      }}
                    >
                      <Box className="btn-content">
                        <span
                          className="label"
                          style={{ fontFamily: "Roboto, sans-serif" }}
                        >
                          もっと見る
                        </span>
                        <Box
                          component="img"
                          src="cases/button-icon.png"
                          alt="arrow"
                          className="arrow arrow-dark"
                          sx={{
                            width: 18,
                            height: 18,
                            objectFit: "contain",
                          }}
                        />
                        <Box
                          component="img"
                          src="cases/button-icon-white.png"
                          alt="arrow white"
                          className="arrow arrow-white"
                          sx={{
                            width: 18,
                            height: 18,
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    </Button>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
        </Grid>
      ))}
    </Grid>
    <Typography
      sx={{ mt: "32px", textAlign: "center", fontSize: "14px" }}
    >
      動画制作をはじめとする受託案件は非公開のため
      <Link href="#contact" sx={{ color: "#1D2D5C" }}>
        お問い合わせ
      </Link>
      より資料をご請求ください
    </Typography>
  </Container>
);

export default Cases;
